import React from 'react'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import Select from 'react-select'
import { fetchSets, addSets, sortSets, searchSets, filterSets } from "../../actions/settings"
import SetsPlaceItem from "./SetsPlaceItem"
import SettingsForm from './SettingsForm'
import { sortOpts } from '../../utils/utils'

class SetsPlace extends SettingsForm {

  componentWillMount(){
    this.props.fetchSets('place');
    this.props.fetchSets('ptype');
    this.setState({
      adding: false,
      data: this.newItem,
      errors: {}
    });
  }

  modelName = 'place'

  newItem = {
    place_desc: '',
    place_active: 1,
    place_ptype_id: 0,
    place_address: '',
    place_contact: '',
    place_price: 0,
    place_price_per: 0,
    place_capacity_ban: 0,
    place_capacity_fur: 0,
    place_note: ''
  };

  handleFilter = e => {
    this.props.filterSets('place',{
      ...this.props.places.filter,
      type: (e ? e.value : 0)
    });
  }

  handlePriceFilter = e => {
    this.props.filterSets('place',{
      ...this.props.places.filter,
      [e.target.name]: parseInt(e.target.value, 10) || 0
    });
  }

  render() {
    if(isEmpty(this.props.places.data) || isEmpty(this.props.ptypes)){
      return(<div>Не загружены данные</div>);
    }
    const { places: { search, filter, sort, data: places }, ptypes } = this.props;
    const { data, errors } = this.state;

    var fltrPlaces = [];
    for(var key in places){
      if(places.hasOwnProperty(key)){
        const active = places[key].place_active === 1;
        var found = true;
        var typeFiltered = true;
        var priceMinFiltered = true;
        var priceMaxFiltered = true;
        var pricePerMinFiltered = true;
        var pricePerMaxFiltered = true;
        var capBanMinFiltered = true;
        var capBanMaxFiltered = true;
        var capFurMinFiltered = true;
        var capFurMaxFiltered = true;
        if(search !== ''){
          const searchValue = "" + places[key].place_desc;
          found = searchValue.toLowerCase().indexOf(search) !== -1;
        }
        if(filter.type !== 0){
          typeFiltered = places[key].place_ptype_id === filter.type;
        }
        if(filter.priceMin !== 0){
          priceMinFiltered = (places[key].place_price >= filter.priceMin);
        }
        if(filter.priceMax !== 0){
          priceMaxFiltered = (places[key].place_price <= filter.priceMax);
        }
        if(filter.pricePerMin !== 0){
          pricePerMinFiltered = (places[key].place_price_per >= filter.pricePerMin);
        }
        if(filter.pricePerMax !== 0){
          pricePerMaxFiltered = (places[key].place_price_per <= filter.pricePerMax);
        }
        if(filter.capBanMin !== 0){
          capBanMinFiltered = (places[key].place_capacity_ban >= filter.capBanMin);
        }
        if(filter.capBanMax !== 0){
          capBanMaxFiltered = (places[key].place_capacity_ban <= filter.capBanMax);
        }
        if(filter.capFurMin !== 0){
          capFurMinFiltered = (places[key].place_capacity_fur >= filter.capFurMin);
        }
        if(filter.capFurMax !== 0){
          capFurMaxFiltered = (places[key].place_capacity_fur <= filter.capFurMax);
        }
        if(
          active &&
          found &&
          typeFiltered &&
          priceMinFiltered &&
          priceMaxFiltered &&
          pricePerMinFiltered &&
          pricePerMaxFiltered &&
          capBanMinFiltered &&
          capBanMaxFiltered &&
          capFurMinFiltered &&
          capFurMaxFiltered
        ){
          fltrPlaces.push(places[key]);
        }
      }
    }

    const srtPlaces = fltrPlaces.sort( (a, b) => {
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.place_id < b.place_id)
         return sort.asc ? -1 : 1
      if(a.place_id > b.place_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const mappedPlaces = srtPlaces ? srtPlaces.map(place =>
      <SetsPlaceItem key={place.place_id}
        data={place}
        ptypes={ptypes}
      />
    ) : [];

    const ptypesOpt = [];
    for (let key in ptypes){
      if(ptypes.hasOwnProperty(key) && (ptypes[key].ptype_active === 1
        || ptypes[key].ptype_id === data.place_ptype_id)) {
        ptypesOpt.push({value:ptypes[key].ptype_id,label:ptypes[key].ptype_desc});
      }
    }
    ptypesOpt.sort(sortOpts);

    const addNew = this.state.adding ?
      <tr>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.place_desc}
              name="place_desc"
              onChange={this.updateInput}
              placeholder="Название"
              autoFocus
            />
          </div>
          <div className="form-inline">
            <button  type="button" className="btn btn-success"
              onClick={this.saveItem} title="Сохранить">
              <span className="glyphicon glyphicon-save"></span>
            </button>{" "}
            <button type="button" className="btn btn-default"
              onClick={this.cancelAdding} title="Отменить">
              <span className="glyphicon glyphicon-remove"></span>
            </button>
          </div>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </td>
        <td>
          <div className="form-group">
            <Select
              clearable={false}
              options={ptypesOpt}
              value={data.place_ptype_id}
              onChange={e => this.updateSelect(e,'place_ptype_id')}
              placeholder="Тип"
            />
          </div>
        </td>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.place_address}
              name="place_address"
              onChange={this.updateInput}
              placeholder="Адрес"
            />
          </div>
        </td>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.place_contact}
              name="place_contact"
              onChange={this.updateInput}
              placeholder="Контакты"
            />
          </div>
        </td>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.place_price}
              name="place_price"
              onChange={this.updateInput}
              placeholder="Цена"
            />
          </div>
        </td>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.place_price_per}
              name="place_price_per"
              onChange={this.updateInput}
              placeholder="Ср.чек"
            />
          </div>
        </td>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.place_capacity_ban}
              name="place_capacity_ban"
              onChange={this.updateInput}
              placeholder="Мест, банкет"
            />
          </div>
        </td>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.place_capacity_fur}
              name="place_capacity_fur"
              onChange={this.updateInput}
              placeholder="Мест, фуршет"
            />
          </div>
        </td>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.place_note}
              name="place_note"
              onChange={this.updateInput}
              placeholder="Заметка"
            />
          </div>
        </td>
      </tr>
      :[];


    return (
      <div>
        <h3 className="pull-right">Настройка площадок</h3>
        <div className="form-group form-inline">
          <button className="btn btn-primary" onClick={this.startAdding}>Создать</button>
          {" "}
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              <button
                type="button"
                className="btn btn-default"
                onClick={this.clearSearch}
                title="Очистить поиск">
                X
              </button>
            </div>
          </div>{" "}
          <div className="input-group">{fltrPlaces.length} записей</div>{" "}
        </div>
        <div className="form-group form-inline">
          <div className="input-group" style={{'zIndex': 3}}>
            <Select
              style={{width:'200px'}}
              options={ptypesOpt}
              value={filter.type || null}
              onChange={this.handleFilter}
              placeholder="Тип площадок"
            />
          </div>
        </div>
        <div
          className="form-group form-inline"
          style={{display: 'flex', justifyContent: 'space-between'}}
        >
          <div>
            <div className="input-group">
              Цена
            </div>{" "}
            <div className="input-group">
              <input
                type="text"
                className="form-control text-right"
                style={{width:'60px'}}
                name="priceMin"
                value={filter.priceMin}
                onChange={this.handlePriceFilter}
              />
            </div> -{" "}
            <div className="input-group">
              <input
                type="text"
                className="form-control text-right"
                style={{width:'60px'}}
                name="priceMax"
                value={filter.priceMax}
                onChange={this.handlePriceFilter}
              />
            </div>
          </div>
          <div>
            <div className="input-group">
              Ср.чек
            </div>{" "}
            <div className="input-group">
              <input
                type="text"
                className="form-control text-right"
                style={{width:'60px'}}
                name="pricePerMin"
                value={filter.pricePerMin}
                onChange={this.handlePriceFilter}
              />
            </div> -{" "}
            <div className="input-group">
              <input
                type="text"
                className="form-control text-right"
                style={{width:'60px'}}
                name="pricePerMax"
                value={filter.pricePerMax}
                onChange={this.handlePriceFilter}
              />
            </div>
          </div>
          <div>
            <div className="input-group">
              Мест
            </div>{" "}
            <div className="input-group">
              <input
                type="text"
                className="form-control text-right"
                style={{width:'60px'}}
                name="capBanMin"
                value={filter.capBanMin}
                onChange={this.handlePriceFilter}
              />
            </div> -{" "}
            <div className="input-group">
              <input
                type="text"
                className="form-control text-right"
                style={{width:'60px'}}
                name="capBanMax"
                value={filter.capBanMax}
                onChange={this.handlePriceFilter}
              />
            </div>
          </div>
          <div>
            <div className="input-group">
              Мест, фуршет
            </div>{" "}
            <div className="input-group">
              <input
                type="text"
                className="form-control text-right"
                style={{width:'60px'}}
                name="capFurMin"
                value={filter.capFurMin}
                onChange={this.handlePriceFilter}
              />
            </div> -{" "}
            <div className="input-group">
              <input
                type="text"
                className="form-control text-right"
                style={{width:'60px'}}
                name="capFurMax"
                value={filter.capFurMax}
                onChange={this.handlePriceFilter}
              />
            </div>
          </div>
        </div>
        <table className="table table-striped table-hover sticky-50">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th className="col-sm-2"
                onClick={() => {this.handleSort('place_desc',this)}}>Название</th>
              <th className="col-sm-1"
                onClick={() => {this.handleSort('place_ptype_id',this)}}>Тип</th>
              <th className="col-sm-2"
                onClick={() => {this.handleSort('place_address',this)}}>Адрес</th>
              <th className="col-sm-1"
                onClick={() => {this.handleSort('place_contact',this)}}>Контакты</th>
              <th className="col-sm-1"
                onClick={() => {this.handleSort('place_price',this)}}>Цена</th>
              <th className="col-sm-1"
                onClick={() => {this.handleSort('place_price_per',this)}}>Ср.чек</th>
              <th className="col-sm-1"
                onClick={() => {this.handleSort('place_capacity_ban',this)}}>Мест</th>
              <th className="col-sm-1"
                onClick={() => {this.handleSort('place_capacity_fur',this)}}>Мест, фуршет</th>
              <th className="col-sm-2"
                onClick={() => {this.handleSort('place_note',this)}}>Заметка</th>
            </tr>
          </thead>
          <tbody>
            {addNew}
            {mappedPlaces}
            <tr onClick={this.startAdding}>
              <td><u>Нажмите, чтобы добавить запись</u></td>
            </tr>
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    places: store.places,
    ptypes: store.ptypes.data
  }
}

export default connect(mapOrdersToProps, { fetchSets, addSets, sortSets, searchSets, filterSets })(SetsPlace);



// WEBPACK FOOTER //
// ./src/components/settings/SetsPlace.js